import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { requestAndRecordStoragePersistence } from "../local/storagePersistence";

// Card #2829 (docs/score/scribe-resilience.md gap G13). Mirrors
// usePresenceHeartbeat's isAuthenticated-gated mount pattern (App.jsx,
// #2364): the effect's only dependency is isAuthenticated, so it fires
// exactly once per sign-in transition (false -> true), never on every
// re-render while it stays true and never before a scribe is signed in.
export function useRequestStoragePersistence() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    requestAndRecordStoragePersistence();
  }, [isAuthenticated]);
}

export default useRequestStoragePersistence;
